import React, {useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import texts from './text.json';

const Biography = () => {
    useEffect(() => {
        AOS.init();
      }, [])
  return (
    <div className="w-[80%] h-[100%] md:h-[100vh] flex flex-col items-center justify-center" > {/* Adjust the margin-top to the height of Hero */}
        <div className="text-[30px] text-white" data-aos="fade-up" data-aos-duration="1200" >Biography</div>
        <div className="text-[35px] md:text-[50px] text-white font-bold mt-2" data-aos="fade-up" data-aos-duration="1700">Who I am?</div>
        <div className="flex flex-row items-center" data-aos="fade-up" data-aos-duration="1400">
          <div className="h-10 md:h-20 w-1 bg-customGreen mt-2 mb-2"></div>
        </div>
        <div className="text-[20px] md:text-[25px] text-customGreen mt-4" data-aos="fade-up" data-aos-duration="1900">About me</div>
        <div className="text-[22px] md:text-[30px] text-white font-semibold" data-aos="fade-up" data-aos-duration="1600">Valerio Pescetelli</div>
        <div className="text-[15px] md:text-[20px] text-white mt-4 w-[90%] md:max-w-[60%] text-center" data-aos="fade-up" data-aos-duration="1700">{texts.biography}</div>
    </div>
  );
}

export default Biography;
